<template>
	<section class="page" v-loading="loadings.main">
		<el-tabs v-model="activeName">
			<el-tab-pane label="待映射得物商品" name="list">
				<div class="content-box" v-if="activeName=='list'">
					<div class="operator">
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleSyncDewuBidding"
							>同步出价</el-button>
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleMapDewuProduct"
							>自动匹配产品</el-button>
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleSyncDewuProduct"
							>同步产品</el-button>
						</div>
					</div>

					<curd-table
						ref="spuTable"
						data-model="Third_product"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						@doEditItem="handleEditItems($event)"
						:list-url="'tool/dewu_spu_list/bill'"
						:list-ops="listOps"
						:has-delete="false"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="全部得物商品" name="all">
				<div class="content-box" v-if="activeName=='all'">
					<div class="operator">
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleSyncDewuBidding"
							>同步出价</el-button>
						</div>
            <div class="operator-col">
              <el-input
                  class="el-input"
                  size="mini"
                  v-model="filterTableSearch"
                  placeholder="品牌方编号/名称"
                  suffix-icon="el-icon-search"
                  clearable
              ></el-input>
            </div>
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterThirdId.value"
									placeholder="第三方编号"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<bool-filter
									size="mini"
									v-model="filterIsItemMapped.value"
									suffix-icon="el-icon-search"
									clearable
									data-model-name="Item"
									field="has_item_mapped"
									field-name="已映射"
							></bool-filter>
						</div>
					</div>
					<curd-table
						ref="spuTable"
						data-model="Third_product"
						:fields="tableFields"
            :search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						@doInit="handleInit($event)"
						:list-url="'tool/dewu_spu_list/all'"
						:list-ops="listOpsAll"
						:has-delete="false"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="分类映射" name="classify">
				<div class="content-box" v-if="activeName=='classify'">
					<div class="operator">
						<div class="operator-col">
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleDewuBrand"
							>同步品牌类型</el-button>
						</div>
					</div>

					<curd-table
						ref="classifyTable"
						data-model="Third_classify"
						:fields="tableMapFields"
						@doedit="handleEditMap('classify',$event)"
						:list-url="'tool/third_list/classify/1'"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="品牌映射" name="brand">
				<div class="content-box" v-if="activeName=='brand'">
					<div class="operator">
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterThirdId.value"
									placeholder="第三方编号"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterTableSearch"
									placeholder="名称"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleDewuBrand"
							>同步全部品牌</el-button>
						</div>
					</div>

					<curd-table
						ref="brandTable"
						data-model="Third_brand"
						:fields="tableMapFields"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						@doedit="handleBrandEdit($event)"
						@doSyncProduct="handleSyncProduct($event)"
						@doSyncClassify="handleSyncClassify($event)"
						:list-url="'tool/third_list/brand/1'"
						:list-ops="listOpsBrand"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="已映射" name="his">
				<div class="content-box" v-if="activeName=='his'">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="doExport">导出</el-button>
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleSyncQty"
							>同步库存</el-button>
						</div>
						<div class="operator-col">
							<el-button
								size="mini"
								@click="handleSyncOrder"
							>同步订单</el-button>
						</div>
						<div class="operator-col">
							<el-input
									class="el-input"
									size="mini"
									v-model="filterTableSearch"
									placeholder="系统货号"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col" style="width:120px">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
					</div>
					<curd-table
						ref="mappedTable"
						data-model="Third_item"
						:fields="tableItemFields"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:has-delete="false"
						:list-url="'tool/dewu_sku_list'"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			data-model-name="Third_product"
			:record-id="editorProductId"
			:fields="editorFields"
			handler-url="tool/do_third_product"
			@change="refreshTable('spuTable')"
		></editor>
    <editor
        :show.sync="editorBrandVisible"
        data-model-name="Third_brand"
        :record-id="editorId"
        :fields="editorBrandFields"
        @change="refreshTable('brandTable')"
    ></editor>
		<el-dialog
			title="尺码"
			:visible.sync="editorItemVisible"
			:append-to-body="true"
			v-if="editorItemVisible"
		>
		<div class="row">
			<div class="col-6">
				<table class="table ">
					<thead>
						<tr >
							<td class="">尺码</td>
							<td class="">id</td>
						</tr>
					</thead>
					<tr v-for="item in dewuItems" :key="item.sku_id">
						<td class="">{{item.properties}}</td>
						<td class="">
							<el-input v-model="item.target._id" v-if="item.target"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<div class="col-6">
				<table class="table">
					<thead>
						<tr >
							<td class="">尺码</td>
							<td class="">id（复制这个）</td>
							<td class="">数量</td>
						</tr>
					</thead>
					<tr v-for="item in items" :key="item._id">
						<td class="">{{item.model.name}}</td>
						<td class="">{{item._id}}</td>
						<td class="">{{item.amount}}</td>
					</tr>
				</table>
			</div>
		</div>
			
			
			<div slot="footer" class="dialog-footer" v-loading="loadings.editor">
				<el-button size="mini" @click="editorItemVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="doConfirmEditItemMapping()" :disabled="!canSubmitItemMapping">确 定</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [Filters, CurdPage],
	data() {
		return {
			loadings: {
				main: false,
				editor:false,
			},
			activeName: "list",
			editorVisible: false,
			editorItemVisible: false,
      editorBrandVisible: false,
			editorDataModel: "Third_product",
			editorProductId: "",
			filterThirdId: { field: "third_id", value: null},
			filterIsItemMapped: { field: "has_mapped_item", value: null},

			listOps: [
				{
					name: "edit",
					show_name: "编辑",
					handler: "doedit",
				},
				{
					name: "editItem",
					show_name: "尺码映射",
					handler: "doEditItem",
				},
			],
			listOpsAll: [
				{
					name: "init",
					show_name: "初始化映射",
					handler: "doInit",
				},
			],
			listOpsBrand:[
				{
					name: "edit",
					show_name: "编辑",
					handler: "doedit",
				},
        {
          name: "syncClassify",
          show_name: "同步分类",
          handler: "doSyncClassify",
        },
				{
					name: "syncProduct",
					show_name: "同步产品",
					handler: "doSyncProduct",
				},
			],
			items: [],
			dewuItems: [],
			tableMapFields: [
				{
					name: "third_id",
					sortable: "custom",
				},
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: 'platform'
				},
        {
          name: 'target',
					sortable: "custom",
        },
				{
					name: 'sync_ts',
					sortable: "custom",
				}
			],
			tableFields: [
				{
					name: "third_id",
          sortable: "custom",
				},
				{
					name: "brand_show_id",
          sortable: "custom",
				},
				{
					name: "color_code",
          sortable: "custom",
				},
				{
					name: "name",
          sortable: "custom",
				},
				{
					name: "pic",
					fieldInfo: {
						oss_style: '',
					},
					params: {
						class:'max-200'
					}
				},
				{
					name: 'target',
					sortable:'custom'
				}
			
			],
			tableItemFields: [
				{
					name: "third_id",
          sortable: "custom",
				},
        {
					name: "spu_id",
          sortable: "custom",
				},
				{
					name: "third_product",
          sortable: "custom",
				},
        {
					name: "properties",
          sortable: "custom",
				},
				{
					name: "brand",
				},
				{
					name: 'target'
				},
				{
					name: 'bidding_no'
				},
				{
					name: 'bidding_type'
				},
				{
					name: 'price',
					render: info => {
						return Math.round(info.price / 100,2);
					},
				},
				{
					name: 'qty'
				},
				{
					name: 'sync_ts'
				}
			],
			editorFields: [ 
				{
					name: "name",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "brand_show_id",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "color_code",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "target",
					col: 12,
					width: '100%',
					fieldInfo: {
						name_fields:["name", "brand_show_id", 'color_code']
					}
				},
			],
      editorBrandFields:[
        {
          name: "third_id",
					isOnlyShow: true,
        },
        {
          name: "name",
					isOnlyShow: true,
        },
        {
          name: 'platform'
        },
        {
          name: 'target'
        }],
		};
	},
	computed: {
		canSubmitItemMapping() {
			// return true;
			for (let item of this.dewuItems) {
				if (!item.target) {
					return false;
				}
			}
			return true;
		}
	},
	created() {},
	mounted() {},
	methods: {
		handleInit(id) {
			this.$confirm("确认初始化映射吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
					.then(() => {
						this.loadings.main = true;
						this.$axios
								.post(`/tool/init_mapping`,{id:id})
								.then(json => {
									this.loadings.main = false;
									this.$message.success(json.data.msg);
									this.refreshTable('spuTable')
								})
								.catch(json => {
									this.loadings.main = false;
									this.$message.error(json.data.msg);
								});
					})
					.catch(() => {
						this.id = "";
						this.$message({
							type: "info",
							message: "已取消",
						});
					});
		},
		handleDewuBrand() {
			this.loadings.main = true;
			this.$axios
				.post("/dewu/sync_brand_classify")
				.then(json => {
					this.loadings.main = false;
				})
				.catch(json => {
					this.loading = false;
					this.$message.error(json.data.msg);
				});
		},
		handleSyncProduct(id){
			this.$confirm("确认同步产品吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
						this.$message.success('操作成功，数据同步需要10-30分钟');
						setTimeout(() => {
							//需要定时执行的代码
							this.refreshTable("brandTable")
						}, 2000)
						this.$axios
								.post("/dewu/do_sync_product",{id:id})
								.then(json => {
									this.$message.success(json.data.msg);
								})
								.catch(json => {
									this.$message.error(json.data.msg);
								});
					})
					.catch(() => {
						this.id = "";
						this.$message({
							type: "info",
							message: "已取消",
						});
					});
		},
		async _handleSyncDewuProduct(brand) {
			this.$message.warning('开始同步' + brand.name +';ID:'+brand.third_id);
			for (let week_page=0;week_page<2;week_page++) {
				try {
					const rst = await this.$axios.post(`/dewu/pullback_products/${brand.third_id}/${week_page}`);
					this.$message.success('brand '+brand.name+',week'+week_page+' 导入 '+rst.data.count+' SKU');
				} catch (e) {
					this.$message.error(e.message);
				}
			}
		},

    handleSyncClassify(id)
    {
      this.$confirm("确认同步分类吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
            .post("/dewu/sync_classify_by_brand_id",{id:id})
            .then(json => {
              this.$message.success(json.data.msg);
              this.refreshTable("brandTable")
            })
            .catch(json => {
              this.$message.error(json.data.msg);
            });
      })
          .catch(() => {
            this.id = "";
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
    },
		
		handleSyncQty() {
			this.loadings.main = true;
			this.$axios
				.post("/dewu/do_sync_qty")
				.then(json => {
					this.loadings.main = false;
				})
				.catch(json => {
					this.loading = false;
					this.$message.error(json.data.msg);
				});
		},
		handleSyncDewuProduct() {
			this.loadings.main = true;
			this.$axios
				.get("tool/third_list/brand/1?page=-999").then(async brand_json => {
					for (let brand of brand_json.data.datas) {
						const product_json = await this._handleSyncDewuProduct(brand);
						this.$message.success('完成' );
					}
				})

			// this._handleSyncDewuProduct2(0,0).then(()=>{
			// 	this.loadings.main = false;
			// 	this.$message.success('完成');
				
			// }).catch(json => {
			// 		this.loadings.main = false;
			// 		this.$message.error(json.data.msg);
			// 	});
		},
		handleSyncDewuBidding() {
			this.loadings.main = true;
			this.$axios
				.post("/dewu/pullback_bidding")
				.then(json => {
					this.loadings.main = false;
					if (json.data.count > 0) {
						this.$message.success('获得出价'+json.data.count+'条');
					}
					if (json.data.miss > 0) {
						this.$message.error('未成功同步'+json.data.miss+'条，需要手动拉取最新产品');
					}
				})
				.catch(json => {
					this.loading = false;
					this.$message.error(json.data.msg);
				});
		},
		async _handleMapDewuProduct(page = 0) {
			const rst = await this.$axios.post(`/dewu/automap_products/${page}`);
			if (rst.data.count>0) {
				this.$message.success('匹配成功'+rst.data.count+'');
			} else {
				this.$message.success('匹配成功'+rst.data.count+'');
			}
			if (page <= rst.data.pages.total / rst.data.pages.perPage) {
				return await this._handleMapDewuProduct(page+1);
			} else {
				return 0;
			}
		},
		handleMapDewuProduct() {
			this.loadings.main = true;
			this._handleMapDewuProduct(0)
				.then(json => {
					this.loadings.main = false;
				})
				.catch(json => {
					this.loading = false;
					this.$message.error(json.data.msg);
				});
		},
		handleSyncOrder() {
			this.loadings.main = true;
			this.$axios
				.post("/dewu/do_sync_order")
				.then(json => {
					this.loadings.main = false;
				})
				.catch(json => {
					this.loading = false;
					this.$message.error(json.data.msg);
				});
		},
		handleEditMap(model_name, id) {
			this.editorProductId = id;
			this.editorVisible = true;
		},
		async refreshItemsData() {
			// this.refreshTable('spuTable');
			try {
				const json = await this.$axios.get(`/tool/dewu_spu_info/${this.editorProductId}`);
				this.items = json.data.items;
				this.dewuItems = json.data.third_items;
				return json;
			} catch (e) {
				throw e;
			}
		},
		handleEdit(id) {
			this.editorProductId = id;
			this.editorVisible = true;
		},
    handleBrandEdit(id) {
      this.editorId = id;
      this.editorBrandVisible = true;
    },
		handleEditItems(id) {
			this.editorProductId = id;
			this.editorItemVisible = true;
			this.loadings.editor = true;
			this.refreshItemsData().then(json => {
				// debugger;
				this.loadings.editor = false;
			}).catch(error => {
				this.loadings.editor = false;
				this.editorItemVisible = false;
				// debugger;
				this.$message.warning(error.data.msg);
			})
		},
		doConfirmEditItemMapping() {
			const items = {};
			for (const item of this.dewuItems) {
				items[item.third_id] = item.target._id || '';
			}
			
			this.$axios.post(`/tool/do_dewu_mapping/${this.editorProductId}`,{items}
			).then(json => {
				this.refreshItemsData().then(json => {
					this.loadings.editor = false;
					this.editorItemVisible = false;
				})
			}).catch(error => {
				this.loadings.editor = false;
				this.editorItemVisible = false;
				this.$message.warning(error.data.msg);
			})
		},
		doExport() {
			this.loadings.filter = true;
			this.$axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
			this.$axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
			this.$axios
					.post(
							'/tool/dewu_export',{},{ responseType: "arraybuffer" }
					)
					.then(res => {
						this.loadings.filter = false;
						let blob = new Blob([res], {
							type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
						});
						let objectUrl = URL.createObjectURL(blob);
						window.location.href = objectUrl;
					})
					.catch(res => {
						console.error(res);
						this.loadings.filter = false;
					});
		},
	},
	watch: {
		"filterThirdId.value": {
			handler(newVal) {
				let val = this.filterThirdId;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, {
						k: val.field,
						t: "int",
						v: val.value,
					});
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
		"filterIsItemMapped.value": {
			handler(newVal) {
				let val = this.filterIsItemMapped;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, {
						k: val.field,
						t: "int",
						v: val.value,
					});
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
	},
	components: {
		Editor,
		CurdTable
	}
};
</script>
<style lang="scss" scoped>
.el-input{
  width: 230px;
}
</style>
